<template>
<!--  Modified vue-gallery-slideshow component -->
  <div>
    <!-- Category Navbar -->
    <nav class="navbar navbar-light navbar-expand-xl">
      <button class="navbar-toggler justify-content-center"
              type="button"
              data-toggle="collapse"
              data-target="#navGallery"
              aria-controls="navGallery" aria-expanded="true" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse collapse justify-content-center" id="navGallery">
        <ul class="navbar-nav text-center" >

          <div v-for="(category, i) in cat" :key="'cat_' + i">
            <li class="nav-item ml-1" v-if="category.name !== $route.params.view" @click="change_view(category.name)">
              <router-link
                      class="nav-link p-1"
                      :to="{name: 'galleryview', params: {view: category.name, title: category.title}}">
                {{category.title}}
              </router-link>
            </li>
          </div>

        </ul>
        </div>

    </nav>
    <!-- Previews -->
    <div class="col-8 offset-2 p-5 text-uppercase">
        <h5 class="pb-3">{{$route.params.title}}</h5>
        <div v-for="(preview, i) in previews" :key="'img_' + i" class="gallery">
        <img :src="preview" height="200px" width="200px" @click="index = i">
        </div>
        <vue-gallery-slideshow 
            :images="images"
            :index="index"
            :thumbs="thumbs"
            @close="index = null"></vue-gallery-slideshow>
    
    </div>

  </div>
</template>

<script>
import VueGallerySlideshow from './slideshow/GallerySlideshow'

export default {
  name: "GalleryView",

  data() {
    return {
      index: null,
      images: [],
      cat: [],
      thumbs: [],
      previews: [],
      selected_view: null
    }
  },

  components: {
    VueGallerySlideshow,
  },

  created() {
    this.cat = this.$store.state.categories;
  },

  watch: {
    '$route.params.view': {
      handler(newVal) {
        if (!newVal) return;

        this.previews = this.$store.state[newVal]['previews'];
        this.images = this.$store.state[newVal]['details'];
        this.thumbs = this.$store.state[newVal]['thumbnails'];
        this.selected_view = newVal;
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
  .gallery {
    display: inline-block;
    position: relative;
    overflow: hidden;
    max-height: 200px;
    max-width: 200px;
    margin-left: 10px;
    img {
        border: 1px solid #DDDDDD;
        padding: 5px;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
        margin: 0 10px 10px 0;
        position: relative;
        display:inline-block;
        background-color: white;
        vertical-align: middle;
        -webkit-transition: all .3s;
        border-radius: 2px;
        text-decoration: none;
        cursor: pointer;
        transition: transform .5s ease;

        &:hover {
          border: 1px solid #AAAAAA;
          transform: scale(1.1);
          box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);

          .image-caption {
            color: #232323;
          }
        }
      }
  }
  @media (min-width: 1200px) {
    li a:after {
      content: '';
      /*position: absolute;*/
      top: 5px;
      height: 100%;
      border-left: 1px solid black;
      margin-left: .5rem;
    }
  }
</style>